import { Injectable } from "@angular/core";
import { Router } from "@angular/router";
import { CanActivate } from "@angular/router";
import { IAppStore } from "../iappstore";
import { Store } from "@ngrx/store";
import { IUser } from "../interfaces/ilogin";
import { IBusinessFunction } from "../interfaces/ibusinessfunction";

/**
 * @WhatItDoes Checks to see if the business function has been set for the user and the user is logged in
 *
 * @HowToUseIt Inject the service
 */
@Injectable()
export class BusinessFunctionGuardService implements CanActivate {
    constructor(private router: Router, private readonly store: Store<IAppStore>) { }

    canActivate(): boolean {
        const currentUrl = this.router.url;
        if (currentUrl === '/login' || currentUrl === '/deloittead' || currentUrl.startsWith('/deloittead') || currentUrl === '/businessfunctionselection') {
            return true;
        }
        // if user is not logged in we'll send them to the login page
        let user: IUser = null as IUser;
        let selectedBusinessFunction: IBusinessFunction = null as IBusinessFunction;

        this.store.select(e => e.user)
            .subscribe(e => {
                user = e;
                if (user) {
                    selectedBusinessFunction = user.selectedBusinessFunction;
                }
            });

        // Check for proper authentication - user must have name or userName to be considered authenticated
        if (!user || (!user.userName && !user.name) || (user.userName === null && user.name === null) || (user.userName === '' && user.name === '')) {
            this.router.navigate(["/login"]);
            return false;
        }
      
        // Check if user has selected a business function - redirect to business function selection if not
      
        if (user && (!selectedBusinessFunction || !selectedBusinessFunction.id)) {
          this.router.navigate(["/businessfunctionselection"]);
            return false;
        }
        return true;
    }
}